import { RouteInfoAlert } from 'entities/ticket/ui/route-info-alert'

import { AllIcons } from 'shared/ui/app-icon/types.ts'

interface Props {
  title?: string
}

export const BaggageWarning = ({ title }: Props) => {
  return <RouteInfoAlert icon={AllIcons.TRIANGLE}>{title}</RouteInfoAlert>
}
